import script from "./CreateBrandForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateBrandForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__